import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {

	Dialog,
	DialogContent,
	DialogTitle,

	Grid,

	Typography,
} from "@mui/material";


export default function AmbassadorTutorialDialog(props) {
	console.log("AmbassadorTutorialDialog", props);
	const { onClose, open } = props;

	const handleClose = () => {
		onClose();
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Vidéo d'aide</DialogTitle>
			<DialogContent dividers>
				{/* <Typography gutterBottom>****</Typography> */}
				<Grid container>
					<Grid item xs={12}>
						<video controls
							src="/images/hint1.mp4"
							//src="/images/uuuu.m4v"
							poster="/images/hint-video.png"
							width="500">

							Sorry, your browser doesn't support embedded videos,
							but don't worry, you can <a href="https://archive.org/details/BigBuckBunny_124">download it</a>
							and watch it with your favorite video player!

						</video>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
}
